import { styled as l } from "@mui/material";
import O from "../hooks/useGetAccountInvitees.js";
import U from "../../temp-lib/components/share/apeiron/ApeironEllipsisTypography.js";
import { ApeironPagingDataGrid as _ } from "../../temp-lib/components/share/apeiron/ApeironPagingDataGrid.js";
import j from "../../temp-lib/components/share/next/NextLink.js";
import E from "../../temp-lib/components/share/popup/InfoPopup.js";
import { INFO_POPUP_TYPE as G } from "../../temp-lib/constants/popup.js";
import { useAccountContext as L } from "../../temp-lib/contexts/account/AccountContext.js";
import { useConfigContext as R } from "../../temp-lib/contexts/config/ConfigContext.js";
import W from "../../ui-lib/components/ApeironSimpleButton.js";
import F from "../../wallet-lib/hooks/useWalletAddress.js";
import { format as M } from "date-fns";
import S from "query-string";
import * as d from "ramda";
import { useState as q, useCallback as b, useMemo as z } from "react";
import { useTranslation as H, Trans as K } from "react-i18next";
import { jsx as r, Fragment as C, jsxs as Y } from "react/jsx-runtime";
const $ = l(W)`
  border-radius: 100px;
  border: 1px solid white;
  font-size: 14px;
  font-weight: 300;
  padding: 1px 18px;
  :hover {
    background-color: unset;
  }
  :disabled {
    background-color: unset;
    color: white;
    opacity: 0.2;
  }
  :focus {
    background-color: unset;
  }
  strong {
    font-size: 16px;
    font-weight: 600;
    margin-right: 4px;
  }
  ${(i) => i.theme.breakpoints.up("res1024")} {
    min-width: unset;
  }
`, J = l(_)`
  padding: 1%;
  margin: auto;
  width: 95%;
  .Custom-Grid {
    .ag-row {
      border-bottom: 1px solid #232326;
    }
    .ag-header-row {
      background-color: #151615;
    }
  }
`, Q = l(j)`
  text-decoration: underline;
`, c = l(U)`
  width: 100%;
  display: flex;
  justify-content: center;
`, V = l(E)`
  height: 90%;
  max-height: 580px;
  max-width: 900px;
  width: 100%;
  .Custom-Content {
    height: 100%;
    overflow-y: auto;
  }
`, pe = (i) => {
  var p, f;
  const {
    t: a
  } = H(), {
    account: n,
    className: v,
    loading: k
  } = i, {
    config: s
  } = R(), {
    account: N
  } = L(), {
    compareAddress: P
  } = F(), m = P(n == null ? void 0 : n.walletAddress, N.walletAddress), [B, T] = q(!1), u = b(() => {
    T((e) => !e);
  }, []), {
    fetch: h
  } = O(), D = z(() => [{
    cellClass: "custom-ag-cell-center",
    field: "start",
    headerClass: "custom-ag-header-center",
    headerName: "",
    pinned: "left",
    sortable: !1,
    width: 10
  }, {
    cellClass: "custom-ag-cell-center",
    field: "name",
    headerClass: "custom-ag-header-center",
    headerName: a("common.grid.name"),
    minWidth: 250,
    sortable: !1,
    cellRenderer: (e) => {
      var t;
      return /* @__PURE__ */ r(c, {
        children: (t = e.data) == null ? void 0 : t.name
      });
    }
  }, {
    cellClass: "custom-ag-cell-center",
    field: "walletAddress",
    flex: 1,
    headerClass: "custom-ag-header-center",
    headerName: a("common.grid.address"),
    minWidth: 300,
    sortable: !1,
    cellRenderer: (e) => {
      var g, w, x, A, y;
      if (d.isNil((g = e.data) == null ? void 0 : g.walletAddress)) return /* @__PURE__ */ r(C, {
        children: " - "
      });
      const t = ((w = s == null ? void 0 : s.adeptus) == null ? void 0 : w.inventoryUrl) || "", o = d.isNotEmpty(t) ? S.stringifyUrl({
        url: t,
        query: {
          ownerWalletAddresses: (x = e.data) == null ? void 0 : x.walletAddress
        }
      }) : "";
      return /* @__PURE__ */ r(c, {
        children: d.isNotEmpty(o) ? /* @__PURE__ */ r(Q, {
          href: o,
          target: "_blank",
          children: (A = e.data) == null ? void 0 : A.walletAddress
        }) : (y = e.data) == null ? void 0 : y.walletAddress
      });
    }
  }, {
    cellClass: "custom-ag-cell-center",
    field: "createdAt",
    headerClass: "custom-ag-header-center",
    headerName: a("believer.join_date"),
    width: 250,
    sortable: !1,
    cellRenderer: (e) => {
      var o;
      const t = (o = e.data) == null ? void 0 : o.createdAt;
      return /* @__PURE__ */ r(c, {
        children: t ? M(new Date(t), "yyyy-MM-dd") : ""
      });
    }
  }], [(p = s == null ? void 0 : s.adeptus) == null ? void 0 : p.inventoryUrl, a]), I = b(async (e, t) => {
    const o = await h({
      isInvitee: !0,
      pageSize: t,
      page: e
    });
    return {
      data: o.data,
      total: o.pageInfo.total
    };
  }, [h]);
  return /* @__PURE__ */ Y(C, {
    children: [/* @__PURE__ */ r($, {
      className: v,
      disabled: k || !m,
      onClick: u,
      children: /* @__PURE__ */ r(K, {
        children: a("account_header.believer", {
          count: ((f = n == null ? void 0 : n.invitation) == null ? void 0 : f.believerCount) || 0
        })
      })
    }), m && /* @__PURE__ */ r(V, {
      open: B,
      type: G.BLACK,
      onClose: u,
      children: /* @__PURE__ */ r(J, {
        columnDefs: D,
        fetch: I,
        rowHeight: 40
      })
    })]
  });
};
export {
  pe as default
};
//# sourceMappingURL=AdeptusBelieverButton.js.map
